import React from 'react';
import { ThemeProvider } from 'styled-components';

import theme from './utils/theme';
import DistantScorm from './components/index/distantScorm';

const App = () => (
  <ThemeProvider theme={theme}>
    <DistantScorm />
  </ThemeProvider>
);

export default App;
